import React, { useState } from 'react';
import { SponsorMessageTemplate } from '../../types/sponsor';
import { MessageSquare, Clock } from 'lucide-react';

interface MessageTemplateFormProps {
  initialTemplate?: Omit<SponsorMessageTemplate, 'id' | 'created_at'>;
  onSubmit: (data: Omit<SponsorMessageTemplate, 'id' | 'created_at'>) => void;
}

export function MessageTemplateForm({ initialTemplate, onSubmit }: MessageTemplateFormProps) {
  const [message, setMessage] = useState(initialTemplate?.message || '');
  const [active, setActive] = useState(initialTemplate?.active ?? true);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      message,
      interval_minutes: 0, // No longer used
      active
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          <div className="flex items-center gap-2">
            <MessageSquare className="w-4 h-4" />
            Message Template
          </div>
        </label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          rows={4}
          required
          placeholder="Thank you to our sponsor [Sponsor Name] for supporting today's tournament!"
        />
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          checked={active}
          onChange={(e) => setActive(e.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        />
        <label className="ml-2 block text-sm text-gray-900">
          Active
        </label>
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          Save Template
        </button>
      </div>
    </form>
  );
}